__turbopack_context__.v({
  "bottom": "SiteFooter-module__wWXZva__bottom",
  "build": "SiteFooter-module__wWXZva__build",
  "copyright": "SiteFooter-module__wWXZva__copyright",
  "disclosure": "SiteFooter-module__wWXZva__disclosure",
  "footer": "SiteFooter-module__wWXZva__footer",
  "links": "SiteFooter-module__wWXZva__links",
  "subscribe": "SiteFooter-module__wWXZva__subscribe",
  "subscribeLede": "SiteFooter-module__wWXZva__subscribeLede",
  "subscribeTitle": "SiteFooter-module__wWXZva__subscribeTitle",
});
